module.exports = __webpack_public_path__ + "img/ic_sunny@3x.2b2f7891.png";